import { type PropsWithChildren } from 'react';
import { PageType } from '@pkgs/components/index';
import { type Country, WizardProvider } from '@ev-tech/lead-flows';

import { PagePropsProvider, usePageProps } from '@/providers/PagePropsProvider';
import { type PropertySearchPageProps } from '@/pages/[marketCountryCode]/[locale]/propertysearch';
import { useSettings } from '@/hooks/useSettings';
import { useSearchApi } from '@/hooks/useSearchApi';

import { ChatbotContactWizard } from './ChatbotContactWizard';

export const SearchPageProviders = ({ children, ...pageProps }: PropsWithChildren<PropertySearchPageProps>) => {
  const searchApi = useSearchApi();
  const { countryCode, language } = useSettings();

  return (
    <PagePropsProvider<PropertySearchPageProps> {...pageProps}>
      <WizardProvider
        environment={searchApi.config.environment}
        country={countryCode.toLowerCase() as Country}
        language={language}
        trackingConfig={{ appId: 'search', page_type: PageType.SEARCH_RESULT }}
      >
        <ChatbotContactWizard />
        {children}
      </WizardProvider>
    </PagePropsProvider>
  );
};

export const useSearchPageProps = usePageProps<PropertySearchPageProps>;
